import { useEffect } from 'react'

//evertel
import { Col, Row } from '@evertel/web/ui'
import { useService } from '@evertel/di'
import { Analytics } from '@evertel/analytics'

const Page500 = () => {

    const analytics = useService(Analytics)

    useEffect(() => {
        analytics.logView('/500')
    }, [])

    return (
        <Row className="login fadeIn animated">
            <Col
                valign="center"
                align="center"
                style={{ minHeight: '100vh', margin: 'auto', overflow: 'auto', maxWidth: 900 }}
            >
                <img
                    src="/assets/img/doughnut-guy.png"
                    className="pb-3"
                    alt="Evertel Doughnut Guy"
                />
                <h1 style={{ fontSize: '4rem' }}>500</h1>
                <h4 className="pt-3">Houston, we have a problem!</h4>
                <p>The page you are looking for is temporarily unavailable.</p>
            </Col>
        </Row>
    )
}

export default Page500
